import { LucideCheckCircle } from 'lucide-react';
import HeaderTwo from '../components/HeaderTwo/HeaderTwoSection';
import Footer from '../components/Footer/FooterSection';
import '../styles/authrequired.scss';
import { NavLink, useSearchParams } from 'react-router-dom';
import { useAnalytics } from '../hooks/useAnalytics';
import { useCart } from '../context/CartContext';
import { useEffect, useRef } from 'react';

const PaymentSuccessful = () => {
 const { trackPurchase } = useAnalytics();
 const { cartData } = useCart();
 const [searchParams] = useSearchParams();
 const hasTrackedRef = useRef(false);

 useEffect(() => {
  // Track purchase event when payment is successful
  const trackPurchaseEvent = async () => {
   if (hasTrackedRef.current) return; // avoid duplicate firing

   const txRef = searchParams.get('trxref') || searchParams.get('reference');
   if (!txRef) return; // no reference, do not track

   if (cartData.length > 0) {
    const totalValue = cartData.reduce((sum, item) => sum + item.totalAmount, 0);

    await trackPurchase(txRef, totalValue, cartData, 'NGN');
    hasTrackedRef.current = true;
   }
  };

  trackPurchaseEvent();
 }, [cartData, searchParams, trackPurchase]);

 return (
  <>
   <HeaderTwo></HeaderTwo>

   {/* <CustomHistory></CustomHistory> */}

   <div className="content authrequired animate__animated animate__fadeIn animate__fast">
    <div className="centerdiv">
     <div className="icon_enter">
      <LucideCheckCircle color="green" size={60}></LucideCheckCircle>
     </div>

     <div className="title">Payment Successful</div>

     <div className="text">Thank you! Your payment has been processed successfully.</div>

     <div className="button-group">
      <NavLink to={'/account/orders'}>
       <div className="btn sign-in">Check Orders</div>
      </NavLink>
     </div>
    </div>
   </div>

   <Footer></Footer>
  </>
 );
};

export default PaymentSuccessful;
